import React from 'react';
import { FeatureGate } from '../../contexts/FeatureFlagContext';
import ContributorsBarChartCard from '../../components/contributors/ContributorsBarChartCard';

export default function ProjectMembersContributorsBarChartSection({
  projectId,
  projectContributorRows,
  projectContributorsLoading,
  contributorsTimeframe,
  contributorsStatus,
  setContributorsTimeframe,
  setContributorsStatus,
}: any) {
  return (
    <FeatureGate flag="ui.projectDetail.contributorsBarChart">
      <div className="mb-6">
        <ContributorsBarChartCard
          contributorRows={projectContributorRows}
          loading={projectContributorsLoading}
          listKey={`project-${projectId}`}
          emptyMessage="No contributor data for this project yet. Sync repositories to load commits."
          timeframe={contributorsTimeframe}
          status={contributorsStatus}
          onTimeframeChange={setContributorsTimeframe}
          onStatusChange={setContributorsStatus}
        />
      </div>
    </FeatureGate>
  );
}
